import auth from "./auth";
import axios from "axios";
let LANGUAGE_CODE = window.navigator.language;
let COUNTRY_CODE = null;
let GEOLOCATION = Intl.DateTimeFormat().resolvedOptions().timeZone;
import { cookie } from "../utils/index";

async function getUserInfo() {
	let userInfo = null;
	try {
		userInfo = (await axios.get(window.USERINFO_URL)).data;
		console.log("[ANALYTICS] [getUserInfo] Got user info", userInfo);
		if (userInfo.language) LANGUAGE_CODE = userInfo.language;
		if (userInfo.country) COUNTRY_CODE = userInfo.country;
		if (userInfo.geo) GEOLOCATION = userInfo.geo;
		updateCookies();
	} catch (e) {
		console.warn("[ANALYTICS] [getUserInfo] Unable to get user info", e);
	}
}

function updateCookies() {
	const token = localStorage.token ? JSON.parse(localStorage.token) : null;
	if (!token) return;
	const cid =
		cookie.get("_ga").split(".")[2] + "." + cookie.get("_ga").split(".")[3];
	console.log(`[ANALYTICS] Got cid as ${cid}`);

	const savedCid = localStorage.cid ? localStorage.cid : null;
	if (savedCid == cid) {
		console.log(`[ANALYTICS] [updateCookies] Already saved cid ${cid}`);
		return;
	}
	axios({
		method: "post",
		url: USERINFO_URL,
		headers: {
			"x-ga-cid": cid,
			authorization: `bearer ${token}`,
		},
	})
		.then((res) => {
			localStorage.cid = cid;
			console.log("[ANALYTICS] [updateCookies] Saved cid as", cid);
		})
		.catch((err) => {});
}

function decorateDatalayerPayload(payload) {
	let decorated = Object.assign({}, payload);
	const user = auth.getUser();
	if (user) {
		decorated.userId = user.id;
		decorated.profile_id = user.id;
		decorated.mobileNumber = user.mobile;
		decorated.mobile = user.mobile;
		decorated.userBalance = user.balance;
		decorated.bonusBalance = user.bonus;
		decorated.pointsBalance = user.points;
		decorated.user = {
			mobile: user.mobile,
			profile_id: user.id,
			id: user.id,
			user_id: user.id,
			wallet_balance: user.balance,
			points_balance: user.points,
			bonus_balance: user.bonus,
		};
	}
	const utm_source = localStorage.getItem("affiliate");
	decorated.app = "MOBILE_WEB";
	decorated.utm_source = utm_source ? utm_source : "n/a";
	decorated.languageCode = LANGUAGE_CODE;
	decorated.country = COUNTRY_CODE;
	decorated.GeoLocation = GEOLOCATION;
	decorated.currency = CURRENCY;
	decorated.environment = process.env.NODE_ENV;
	console.log("[ANALYTICS] decoratedDatalayerPayload: ", decorated);
	return decorated;
}

function decorateFbPixelPayload(payload) {
	let decorated = Object.assign({}, payload);
	const user = auth.getUser();
	if (user) {
		decorated.user_id = user.id;
		decorated.mobile = user.mobile;
		decorated.userBalance = user.balance;
		decorated.bonusBalance = user.bonus;
		decorated.pointsBalance = user.points;
	}
	decorated.currency = CURRENCY;
	return decorated;
}

const analytics = {
	getUserInfo,
	registration: {
		// Customer starts the registration process step 1 (Phone number and send code)
		attempt(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "registrationAttempt",
						eventCategory: "Registration",
						affiliateID: data.affiliateID || null,
						mobileNumber: data.mobile || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->attempt] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully saves mobile number and password
		start(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "registrationStart",
						eventCategory: "Registration",
						email: null,
						mobileNumber: data.mobile || null,
						affiliateID: data.affiliateID || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->start] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer registration successful (verified or if no OTP, successful signup)
		success(data) {
			try {
				fbq("trackCustom", "RegisterLite", {
					mobile: data.mobile,
					message: data.message,
				});
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->success] fbPixel tracking failed",
					e
				);
			}

			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "registrationSuccess",
						eventCategory: "Registration",
						regDate: +new Date(),
						mobileNumber: data.mobile || null,
						userId: data.user_id || null,
						affiliateID: data.affiliateID || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->success] Datalayer tracking failed",
					e
				);
			}

			try {
				dataLayer.push({
					event: "signup",
					app: "MOBILE_WEB",
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				});
				dataLayer.push(
					decorateDatalayerPayload({
						event_name: "RegisterMobileWeb",
						mobile: data.mobile || null,
					})
				);
			} catch (e) {
				console.warn(
					"[LEGACY ANALYTICS] [registration->success] Datalayer tracking failed",
					e
				);
			}
		},
		verify(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "registrationVerified",
						eventCategory: "Registration",
						verifyDate: +new Date(),
						mobileNumber: data.mobile || null,
						userId: data.user_id || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->verify] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer registration fails
		failed(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "registrationFail",
						eventCategory: "Registration",
						mobileNumber: data.mobile || null,
						affiliateID: data.affiliateID || null,
						failRegReason: data.message,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->failed] Datalayer tracking failed",
					e
				);
			}
		},
	},
	kyc: {
		// Customer submits kyc form
		attempt(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "initialKycAttempt",
						eventCategory: "KYC",
						affiliateID: data.affiliateID || null,
						mobileNumber: data.mobile || null,
					})
				);
			} catch (e) {
				console.warn("[ANALYTICS] [kyc->attempt] Datalayer tracking failed", e);
			}
		},
		// Customer successfully saves kyc details
		start(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "initialKycStart",
						eventCategory: "KYC",
						mobileNumber: data.mobile || null,
						affiliateID: data.affiliateID || null,
					})
				);
			} catch (e) {
				console.warn("[ANALYTICS] [kyc->start] Datalayer tracking failed", e);
			}
		},
		// Customer kyc submission successful
		success(data) {
			try {
				fbq("trackCustom", "InitialKYCLite", {
					mobile: data.mobile,
					message: data.message,
				});
			} catch (e) {
				console.warn("[ANALYTICS] [kyc->success] fbPixel tracking failed", e);
			}

			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "initialKycSuccess",
						eventCategory: "KYC",
						submissionDate: +new Date(),
						mobileNumber: data.mobile || null,
						userId: data.user_id || null,
						affiliateID: data.affiliateID || null,
					})
				);
			} catch (e) {
				console.warn("[ANALYTICS] [kyc->success] Datalayer tracking failed", e);
			}

			try {
				dataLayer.push({
					event: "initialKyc",
					app: "MOBILE_WEB",
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				});
				dataLayer.push(
					decorateDatalayerPayload({
						event_name: "KycMobileWeb",
						mobile: data.mobile || null,
					})
				);
			} catch (e) {
				console.warn(
					"[LEGACY ANALYTICS] [kyc->success] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer registration fails
		failed(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "initialKycFail",
						eventCategory: "KYC",
						mobileNumber: data.mobile || null,
						affiliateID: data.affiliateID || null,
						failRegReason: data.message,
					})
				);
			} catch (e) {
				console.warn("[ANALYTICS] [kyc->failed] Datalayer tracking failed", e);
			}
		},
	},
	login: {
		// Customer clicks login after filling in information
		attempt(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "loginAttempt",
						eventCategory: "Login",
						mobileNumber: data.mobile || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [login->attempt] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer login successfull
		success(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "loginSuccess",
						eventCategory: "Login",
						mobileNumber: data.mobile || null,
						userId: data.user_id || null,
						affiliateID: data.affiliate_id || null,
						VIPlvl: data.vip_level || null,
						userBalance: data.wallet_balance || null,
						bonusBalance: data.bonus_balance || null,
						pointsBalance: data.points_balance || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [login->success] Datalayer tracking failed",
					e
				);
			}

			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event_name: "LoginMobileWeb",
						profile_id: data.user_id || null,
						mobile: data.mobile || null,
						wallet_balance: data.wallet_balance || null,
						points_balance: data.points_balance || null,
						bonus_balance: data.bonus_balance || null,
					})
				);

				dataLayer.push(
					decorateDatalayerPayload({
						event: "login",
						form: { type: "login", id: "login" },
						user: {
							id: data.user_id || null,
							mobile: data.mobile || null,
							wallet_balance: data.wallet_balance || null,
							points_balance: data.points_balance || null,
							bonus_balance: data.bonus_balance || null,
						},
					})
				);
			} catch (e) {
				console.warn(
					"[LEGACY ANALYTICS] [login->success] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer login failed
		failed(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "loginFailed",
						eventCategory: "Login",
						mobileNumber: data.mobile || null,
						affiliateID: data.affiliate_id || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [login->attempt] Datalayer tracking failed",
					e
				);
			}
		},
	},
	logout: {
		success() {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "logoutSuccess",
						eventCategory: "Logout",
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [logout->success] Datalayer tracking failed",
					e
				);
			}
		},
	},
	deposit: {
		// Customer clicks deposit after filling in information
		attempt(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "depositAttempt",
						eventCategory: "Deposit",
						depositMethod: data.depositMethod || null,
						depositAmount: data.depositAmount || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [deposit->attempt] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully starts the deposit process
		start(data) {
			try {
				fbq("trackCustom", "DepositMobileWeb", {
					user_id: data.user_id,
					value: data.depositAmount,
					currency: CURRENCY,
				});
			} catch (e) {
				console.warn(
					"[ANALYTICS] [deposit->start] Facebook pixel tracking failed",
					e
				);
			}

			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "depositPending",
						eventCategory: "Deposit",
						depositMethod: data.depositMethod || null,
						depositAmount: data.depositAmount || null,
					})
				);
				if (data.isFirstDeposit) {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "firstDeposit",
							eventCategory: "Deposit",
							depositMethod: data.depositMethod || null,
							depositAmount: data.depositAmount || null,
						})
					);
				} else {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "repeatingDeposit",
							eventCategory: "Deposit",
							depositMethod: data.depositMethod || null,
							depositAmount: data.depositAmount || null,
						})
					);
				}
			} catch (e) {
				console.warn(
					"[ANALYTICS] [deposit->start] Datalayer tracking failed",
					e
				);
			}

			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event_name: "DepositMobileWeb",
						app_name: "MOBILE_WEB",
						amount: data.depositAmount,
					})
				);

				dataLayer.push(
					decorateDatalayerPayload({
						event: "depositInitiated",
						app: "MOBILE_WEB",
						deposit: {
							amount: data.depositAmount,
						},
					})
				);
			} catch (e) {}
		},
		// Customer fails to start the deposit process
		failed(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "depositFailed",
						eventCategory: "Deposit",
						depositMethod: data.depositMethod || null,
						depositAmount: data.depositAmount || null,
						depositFailureReason: data.message || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [deposit->failed] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully completes a deposit (Backend)
		success(data) {},
		// Customer successfully completes a first time deposit (Backend)
		first(data) {},
		// Customer successfully completes a repeat deposit (Backend)
		repeat(data) {},
	},
	withdraw: {
		// Customer clicks withdraw after filling in information
		attempt(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "withdrawAttempt",
						eventCategory: "Withdraw",
						withdrawMethod: data.withdrawMethod || null,
						withdrawAmount: data.withdrawAmount || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [withdraw->deposit] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully starts the withdrawal process
		start(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "withdrawPending",
						eventCategory: "Withdraw",
						withdrawMethod: data.withdrawMethod || null,
						withdrawAmount: data.withdrawAmount || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [withdraw->pending] Datalayer tracking failed",
					e
				);
			}

			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event_name: "WithdrawMobileWeb",
						app_name: "MOBILE_WEB",
						amount: data.withdrawAmount,
					})
				);

				dataLayer.push(
					decorateDatalayerPayload({
						event: "withdrawSuccessful",
						app: "MOBILE_WEB",
						withdraw: {
							amount: data.withdrawAmount,
						},
					})
				);
			} catch (e) {
				console.warn(
					"[LEGACY ANALYTICS] [withdraw->pending] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer fails to start the withdrawal process
		failed(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "withdrawFailed",
						eventCategory: "Withdraw",
						withdrawMethod: data.withdrawMethod || null,
						withdrawAmount: data.withdrawAmount || null,
						withdrawFailureReason: data.message || null,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [withdraw->failed] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully completes a withdrawal (Backend)
		success(data) {},
		// Customer withdrawal pending (Backend)
		pending(data) {},
		// Customer cancels a withdrawal (Backend)
		cancel(data) {},
	},
	bet: {
		sportsbook: {
			add(data) {
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "sportsbookBetAdd",
							eventCategory: "Sportsbook",
							bet_type: data.bet_type,
							parent_match_id: data.parent_match_id,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->add] Datalayer tracking failed",
						e
					);
				}
			},
			start(data) {
				try {
					fbq(
						"trackCustom",
						"InitiateBetMobileWeb",
						decorateFbPixelPayload({
							betType: data.bet_type,
							num_items: data.no_of_bets,
							value: data.bet_amount,
							events: data.events,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->start] FBPixel tracking failed",
						e
					);
				}
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "sportsbookBetAttempt",
							eventCategory: "Sportsbook",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							events: data.events,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->start] Datalayer tracking failed",
						e
					);
				}
			},
			success(data) {
				try {
					fbq(
						"trackCustom",
						data.first_time ? "FTPlaceBetMobileWeb" : "PlaceBetMobileWeb",
						decorateFbPixelPayload({
							betType: data.bet_type,
							num_items: data.no_of_bets,
							value: data.bet_amount,
							message: data.message,
							events: data.events,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->success] FBPixel tracking failed",
						e
					);
				}
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "sportsbookBetPlacement",
							eventCategory: "Sportsbook",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							betId: data.bet_id,
							events: data.events,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->success] Datalayer tracking failed",
						e
					);
				}

				// Legacy datalayer
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event_name: "PlaceBetMobileWeb",
							app_name: "MOBILE_WEB",
							betType: data.bet_type,
							num_items: data.no_of_bets,
							amount: data.bet_amount,
							channel: "mobile_web",
							events: data.events,
							bet_id: data.bet_id,
						})
					);

					dataLayer.push(
						decorateDatalayerPayload({
							event: data.first_bet ? "firstBet" : "betPlacedSuccessful",
							app: "MOBILE_WEB",
							bet: {
								id: data.bet_id,
								amount: data.bet_amount,
								betType: data.bet_type,
								numberOfMatches: data.no_of_bets,
								odds: data.total_odds,
								events: data.events,
							},
						})
					);
				} catch (e) {
					console.warn(
						"[LEGACY ANALYTICS] [bet->sportsbook->success] Datalayer tracking failed",
						e
					);
				}
			},
			failed(data) {
				try {
					fbq(
						"trackCustom",
						"FailedBetMobileWeb",
						decorateFbPixelPayload({
							betType: data.bet_type,
							num_items: data.no_of_bets,
							value: data.bet_amount,
							message: data.message,
							events: data.events,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->failed] FBPixel tracking failed",
						e
					);
				}

				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "sportsbookBetFailed",
							eventCategory: "Sportsbook",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							message: data.message,
							events: data.events,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->failed] Datalayer tracking failed",
						e
					);
				}
			},
		},
		virtuals: {
			add(data) {
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "virtualsBetAdd",
							eventCategory: "Virtuals",
							bet_type: data.bet_type,
							parent_match_id: data.parent_match_id,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->virtuals->add] Datalayer tracking failed",
						e
					);
				}
			},
			start(data) {
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "virtualsBetAttempt",
							eventCategory: "Virtuals",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->virtuals->start] Datalayer tracking failed",
						e
					);
				}
			},
			success(data) {
				try {
					fbq(
						"trackCustom",
						"PlaceVirtualBetMobileWeb",
						decorateFbPixelPayload({
							betType: "virtual_match",
							num_items: data.no_of_bets,
							value: data.bet_amount,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->virtuals->success] FBPixel tracking failed",
						e
					);
				}

				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "virtualsBetPlacement",
							eventCategory: "Virtuals",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							betId: data.bet_id,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->virtuals->success] Datalayer tracking failed",
						e
					);
				}

				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event_name: "PlaceBetMobileWeb",
							app_name: "MOBILE_WEB",
							betType: "virtuals",
							num_items: data.no_of_bets,
							amount: data.bet_amount,
							channel: "mobile_web",
							bet_id: data.bet_id,
						})
					);

					dataLayer.push(
						decorateDatalayerPayload({
							event_name: "betPlacedSuccessful",
							app: "MOBILE_WEB",
							bet: {
								id: data.bet_id,
								amount: data.bet_amount,
								betType: "virtual",
								numberOfMatches: data.no_of_bets,
								odds: data.total_odds,
							},
						})
					);
				} catch (e) {
					console.warn(
						"[LEGACY ANALYTICS] [bet->virtuals->success] Datalayer tracking failed",
						e
					);
				}
			},
			failed(data) {
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "virtualsBetFailed",
							eventCategory: "Virtuals",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->virtuals->failed] Datalayer tracking failed",
						e
					);
				}
			},
		},
		shikisha: {
			add(data) {
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "shikishaBetAdd",
							eventCategory: "Sportsbook",
							bet_type: data.bet_type,
							parent_match_id: data.parent_match_id,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->add] Datalayer tracking failed",
						e
					);
				}
			},
			start(data) {
				try {
					fbq(
						"trackCustom",
						"InitiateBetMobileWeb",
						decorateFbPixelPayload({
							betType: "bet-builder",
							num_items: data.no_of_bets,
							value: data.bet_amount,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->start] FBPixel tracking failed",
						e
					);
				}

				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "shikishaBetAttempt",
							eventCategory: "Shikisha",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->start] Datalayer tracking failed",
						e
					);
				}
			},
			success(data) {
				try {
					fbq(
						"trackCustom",
						data.first_bet ? "FTPlaceBetMobileWeb" : "PlaceBetMobileWeb",
						decorateFbPixelPayload({
							betType: "bet-builder",
							num_items: data.no_of_bets,
							value: data.bet_amount,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->success] FBPixel tracking failed",
						e
					);
				}
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "shikishaBetPlacement",
							eventCategory: "Shikisha",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							betId: data.bet_id,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->success] Datalayer tracking failed",
						e
					);
				}

				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event_name: "PlaceBetMobileWeb",
							app_name: "MOBILE_WEB",
							betType: "shikisha",
							num_items: data.no_of_bets,
							amount: data.bet_amount,
							channel: "mobile_web",
							bet_id: data.bet_id,
						})
					);

					dataLayer.push(
						decorateDatalayerPayload({
							event: data.first_bet ? "firstBet" : "betPlacedSuccessful",
							app: "MOBILE_WEB",
							bet: {
								id: data.bet_id,
								amount: data.bet_amount,
								betType: "shikisha",
								numberOfMatches: data.no_of_bets,
								odds: data.total_odds,
							},
						})
					);
				} catch (e) {
					console.warn(
						"[LEGACY ANALYTICS] [bet->shikisha->success] Datalayer tracking failed",
						e
					);
				}
			},
			failed(data) {
				try {
					fbq(
						"trackCustom",
						"FailedBetMobileWeb",
						decorateFbPixelPayload({
							betType: "bet-builder",
							num_items: data.no_of_bets,
							value: data.bet_amount,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->failed] FBPixel tracking failed",
						e
					);
				}

				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "shikishaBetFailed",
							eventCategory: "Shikisha",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->failed] Datalayer tracking failed",
						e
					);
				}
			},
		},
		jackpots: {
			add(data) {
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "jackpotBetAdd",
							eventCategory: "Jackpot",
							bet_type: data.bet_type,
							parent_match_id: data.parent_match_id,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->add] Datalayer tracking failed",
						e
					);
				}
			},
			autopick(data) {
				try {
					fbq(
						"trackCustom",
						"JackpotAutoPickMobile",
						decorateFbPixelPayload({
							jackpotEventId: data.event_id,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->failed] FBPixel tracking failed",
						e
					);
				}

				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "jackpotBetAutopick",
							eventCategory: "Jackpot",
							betType: data.bet_type,
							jackpotEventId: data.event_id,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->autopick] Datalayer tracking failed",
						e
					);
				}
			},
			start(data) {
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "jackpotBetAttempt",
							eventCategory: "Jackpot",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							combinations: data.combinations,
							jackpotEventId: data.event_id,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->start] Datalayer tracking failed",
						e
					);
				}
			},
			success(data) {
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "jackpotBetPlacement",
							eventCategory: "Jackpot",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							combinations: data.combinations,
							jackpotEventId: data.event_id,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->success] Datalayer tracking failed",
						e
					);
				}
			},
			failed(data) {
				try {
					dataLayer.push(
						decorateDatalayerPayload({
							event: "jackpotBetFailed",
							eventCategory: "Jackpot",
							betType: data.bet_type,
							numOfBets: data.no_of_bets,
							stake: data.bet_amount,
							combinations: data.combinations,
							jackpotEventId: data.event_id,
							message: data.message,
						})
					);
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->failed] Datalayer tracking failed",
						e
					);
				}
			},
		},
	},
	casino: {
		play(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: data.mode,
						eventCategory: "Casino",
						gameName: data.gameName,
						gameProvider: data.gameProvider,
						gameCode: data.gameCode,
						category: data.category,
						gameID: data.gameID,
					})
				);
			} catch (e) {
				console.warn("[ANALYTICS] [casino->play] Datalayer tracking failed", e);
			}
		},
		close(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "closeCasinoSession",
						eventCategory: "Casino",
						gameName: data.gameName,
						gameProvider: data.gameProvider,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [casino->close] Datalayer tracking failed",
					e
				);
			}
		},
	},
	regulatory: {
		selfExclusion(data) {},
		kycCompleted(data) {},
		cookieConsent(data) {},
	},
	general: {
		printMatches(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "DownloadFixtures",
						type: data.type,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [general->printMatches] Datalayer tracking failed",
					e
				);
			}
		},
		pageMetaData(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "pageMetaData",
						page: {
							type: data.type,
							title: data.title,
							path: data.path,
						},
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [general->pageMetaData] Datalayer tracking failed",
					e
				);
			}
		},
		pageHit(data) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "pageHit",
						eventCategory: "General",
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [general->pageHit] Datalayer tracking failed",
					e
				);
			}
		},
		languageCodeChange(data) {},
	},
	recommendations: {
		see(payload) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "seeRecommendation",
						eventCategory: "Recommendations",
						ids: payload.ids,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [recommendations->see] Datalayer tracking failed see",
					e
				);
			}
		},
		add(payload) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "addRecommendation",
						eventCategory: "Recommendations",
						id: payload.parent_match_id,
						home_team: payload.home_team,
						away_team: payload.away_team,
						market: payload.market,
						odd_key: payload.odd_key,
						odd_value: payload.odd_value,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [recommendations->see] Datalayer tracking failed add",
					e
				);
			}
		},
		place(payload) {
			try {
				dataLayer.push(
					decorateDatalayerPayload({
						event: "placeRecommendation",
						eventCategory: "Recommendations",
						ids: payload.ids,
						ref: payload.ref,
					})
				);
			} catch (e) {
				console.warn(
					"[ANALYTICS] [recommendations->place] Datalayer tracking failed place",
					e
				);
			}
		},
	},
};

export default analytics;
